import React, { useState, useEffect } from 'react';
import { useSetting } from '../../../util/useSetting';
import PreviousSvg from '../../../svg/student/Previous.js';
import NextSvg from '../../../svg/student/Next.js';
import ReloadSvg from '../../../svg/student/Reload.js';
import { connect } from 'react-redux';
import Instruction from '../Instruction';
import SettingPopup from './SettingPopup.js';
import { useNavigate } from 'react-router-dom';


function ShortTask(props) {
    const { fontSize } = useSetting();
    const [questions, setQuestions] = useState(props.data)
    const [questionIndex, setQuestionIndex] = useState(0);
    const [showInstructions, setShowInstructions] = useState(false);
    const [isSettingMenuVisible, setIsSettingMenuVisible] = useState(false);
      const [showConfirmPopup, setShowConfirmPopup] = useState(false);
    const navigate = useNavigate();

    const [startTime, setStartTime] = useState(props.startTime);
    const [timer, setTimer] = useState('00:00');//10 minutes
        useEffect(() => {
            function updateTimer() {
                const now = new Date().getTime();
                const elapsed = now - startTime;
                const remaining = Math.max(0, 5 * 60 * 1000 - elapsed); // 5 minutes in milliseconds
                const minutes = Math.floor(remaining / 60000);
                const seconds = Math.floor((remaining % 60000) / 1000);
                setTimer(`${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
            }

            const interval = setInterval(updateTimer, 1000);
            return () => clearInterval(interval);
        }, [startTime]);
    return (
        <div className='w-full flex flex-col h-full' style={{ fontSize }}>

            <div className='w-full flex flex-row justify-start gap-[8px] mt-[16px] px-[16px] font-[900]'>
                <button className='px-[18px] py-[4px] rounded-full flex flex-row items-center text-[white] gap-[8px] noto-san-hk font-[600]' style={{ background: 'linear-gradient(to right, #34778C, #63BBD1)' }} onClick={() => setIsSettingMenuVisible(!isSettingMenuVisible)}>
                    <img src='/secondary/setting.png' alt='設定' />
                    設定
                </button>
                <div className='flex flex-row gap-[8px]'>
                    {questions?.map((question, index) => (
                        question.type === 'display-text' ? null :
                            <button className='w-[40px] h-[40px] rounded-[6px] flex items-center justify-center text-bold' style={{
                                background: questionIndex === index ? '#003A57' : questionIndex > index ? '#178E95' : 'linear-gradient(to bottom, #BEBEBE80, #F0FBFF)',
                                color: questionIndex === index ? 'white' : questionIndex < index ? 'white' : 'black'
                            }} key={index}
                                onClick={() => setQuestionIndex(index)}>{question?.id}</button>
                    ))}
                </div>
                {props.startTime && <div className='flex flex-row gap-[8px]'>
                    <div className='flex items-center justify-center'>
                        <div className='text-white bg-[#003A57] py-[8px] px-[24px] rounded-[4px]' style={{ fontSize: fontSize }}>{timer}</div>
                    </div>
                </div>}
                <div className='flex flex-row gap-[8px] flex-1 justify-end'>
                    <button>
                        <img src='/secondary/btn1.png' onClick={() => { setShowInstructions(true) }} />
                    </button>
                    <button>
                        <img src='/secondary/btn2.png' onClick={() => { if (questionIndex > 0) setQuestionIndex(questionIndex - 1) }} />
                    </button>
                    <button>
                        <img src='/secondary/btn3.png' onClick={() => { if (questionIndex < questions.length - 1) setQuestionIndex(questionIndex + 1) }} />
                    </button>
                </div>


            </div>
            <div className='w-full flex flex-row justify-start gap-[8px] mt-[16px] px-[16px] font-[900]'>
                <button
                    className='flex-1 max-w-[220px] overflow-hidden text-ellipsis whitespace-nowrap text-center py-[4px]'
                    style={true ? { background: 'linear-gradient(to left, #108B96, #003A57)', color: 'white', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' } : { background: 'linear-gradient(to bottom, #ccc, #fff)', color: '#003A57', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}
                    onClick={() => { }}
                >
                    短篇閱讀
                </button>
            </div>
            <div className='w-full flex flex-row bg-[white] items-center' style={{ borderBottom: '1px solid #E3E3E3', marginTop: 4, gap: 6, padding: 6 }}>
                <div className='cursor-pointer'>
                    <PreviousSvg height={30} width={30} />
                </div>
                <div className='cursor-pointer'>
                    <NextSvg height={30} width={30} />
                </div>
                <div className='cursor-pointer'>
                    <ReloadSvg height={30} width={30} />
                </div>
                <div className='flex-1'>
                    <input disabled={true} className='w-full text-[black] bg-[#EEF2F6] rounded-[4px]' value={'https://task1.com'} style={{ fontSize: fontSize - 4, height: 40, paddingLeft: 24, paddingRight: 24 }} />
                </div>
            </div>

            <div className='w-full flex flex-col items-center flex-1 overflow-auto noto-san-hk bg-[#F8FAFB]'>
                <div className='w-full'>
                    <img src={'/secondary/tasks/rp1.png'} alt='' className='w-full' />
                </div>


                <div className='w-full flex flex-col items-start'>
                    {questions?.[questionIndex]?.type === '選擇題' ?
                        <div className='w-full flex flex-col relative font-bold' style={{ background: questions[questionIndex].background || 'none' }}>
                            {questions[questionIndex].backgroundImage && <img className='w-full z-[1]' src={questions[questionIndex].backgroundImage} alt='' style={{ objectFit: 'contain' }} />}
                            <div className={questions[questionIndex].backgroundImage ? 'inset-0 absolute z-[2] flex flex-col px-[15%] justify-center items-start' : 'flex flex-col w-full px-[15%] justify-center items-start py-[64px]'}>
                                <div className='w-full text-[black] mb-[24px] font-[900]' dangerouslySetInnerHTML={{ __html: questions[questionIndex].text }} />
                                <div className='w-full text-[black] mb-[24px]'>{questions[questionIndex].question}</div>
                                <div className='w-full flex flex-col gap-[4px]'>
                                    {questions[questionIndex].options.map((option, oi) =>
                                        <div key={oi} className='w-full text-[black] flex flex-row items-center gap-[16px]'>
                                            <button className='w-[20px] h-[20px] border border-[#005B8C] rounded-full flex-shrink-0' style={{ backgroundColor: option.selected ? '#005B8C' : 'transparent' }} onClick={
                                                () => {
                                                    let newQuestions = [...questions]
                                                    for (let op of newQuestions[questionIndex].options) {
                                                        op.selected = false
                                                    }
                                                    newQuestions[questionIndex].options[oi].selected = true
                                                    setQuestions(newQuestions)
                                                }
                                            }>

                                            </button>
                                            {option.text}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        : null}

                </div>

            </div>
            <div className='flex flex-row justify-center bg-[#F8FAFB] py-[16px]'>
                <button onClick={() => {
                    if (questionIndex < questions.length - 1) {
                        setQuestionIndex(questionIndex + 1)
                    } else {
                        setShowConfirmPopup(true)
                    }
                }} className='text-[#007A83] font-bold mb-[6px] mr-[8px] noto-san-hk text-white p-[2px] rounded-full' style={{ fontSize: fontSize - 2, background: 'linear-gradient(to left, #015B6B, #00E9BA)' }}>
                    <div className='rounded-full px-[48px] py-[6px] ' style={{ border: '2px solid #eee', background: 'linear-gradient(to right, #015B6B, #00E9BA)' }}>
                        {questionIndex === questions.length - 1 ? '提交並進入閱讀任務' : '下一題'}
                    </div>
                </button>
            </div>
             {showConfirmPopup && <div className='absolute top-0 left-0 w-full h-full flex justify-center items-center bg-white bg-opacity-50 noto-san-hk font-bold' style={{ backdropFilter: 'blur(18px)' }}>
                <div className='bg-white p-[24px] rounded-[8px] flex flex-col items-center gap-[16px]' style={{ boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', backgroundImage: 'url(/secondary/bg7.png)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                    <div className='text-[#6E0526] font-bold mb-[16px]'>小提示</div>
                    <div className='mb-[16px] text-center'>提交後將不能返回修改本部分答案，<br />是否繼續？</div>
                    <div className='flex flex-row gap-[16px]'>
                        <button className='px-[16px] py-[8px] text-black rounded-[4px] min-w-[200px] text-center rounded-full' style={{ background: 'linear-gradient(to bottom, #BEBEBE80, #FFFFFF)' }} onClick={() => setShowConfirmPopup(false)}>返回檢查</button>
                        <button className='px-[16px] py-[8px] bg-[#007A83] text-white rounded-[4px] min-w-[200px] text-center rounded-full' onClick={() => { props.onSubmit() }}>確認</button>
                    </div>
                </div>
            </div>}
            {showInstructions && (
                <Instruction close={() => setShowInstructions(false)} />
            )}

            {isSettingMenuVisible && (
                 <SettingPopup onClose={() => {navigate('/platform2/research-practices')}} onReturn={() => setIsSettingMenuVisible(false)} enableReturn={true} />
            )}

        </div>
    )
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(ShortTask)
